export default __webpack_public_path__ + "static/media/room-1.05b90599.jpg";